"use client";

import { Box } from "@mui/material";
import cn from "clsx";
import { forwardRef } from "react";
import { CarouselItemProps } from "../lib/type";
import { useCarousel } from "./CarouselWrapper";

const CarouselItem = forwardRef<HTMLDivElement, CarouselItemProps>(
    ({ className, ...props }, ref) => {
        const { orientation } = useCarousel();

        return (
            <Box
                ref={ref}
                role={"group"}
                aria-roledescription={"slide"}
                className={cn(
                    "min-w-0 shrink-0 grow-0 basis-full",
                    orientation === "horizontal" ? "pl-4" : "pt-4",
                    className,
                )}
                {...props}
            />
        );
    },
);
CarouselItem.displayName = "CarouselItem";
export { CarouselItem };